import React from 'react'
import "./about.css";
import Myimage from "../../assets/My_picture.jpg";
import {FaAward} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {VscFolderLibrary} from 'react-icons/vsc';
const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
       <div className="about__me">
         <div className="about__me__image">
           <img src={Myimage} alt="my_photo" />
         </div>
       </div>
       <div className="about__content">
        <div className="about__cards">
          <article className="about__card">
            <FaAward className="about__icon"/>
            <h5>Experience</h5>
            <small>4+ months working</small>
          </article>

          <article className="about__card">
            <FiUsers className="about__icon"/>
            <h5>Clients</h5>
            <small>5 in pakistan</small>
          </article>

          <article className="about__card">
            <VscFolderLibrary className="about__icon"/>
            <h5>Projects</h5>
            <small>5 Completed</small>
          </article>
          </div> 
          <p>
          I am a keen learner with a can-do attitude. I like to work with people who drive me forward. When I see that other people try their best at work, it motivated
me to also push hard.        </p>
          <a href="#contact" class="btn btn-primary">Let's Talk</a>
        </div> 
      </div>
    </section>
  )
}

export default About